var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNobulLogo = function SvgNobulLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 2,
    fill: "#CCF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.565 6.9h1.542a.296.296 0 01.3.292v3.863a.147.147 0 01-.282.058c-.658-1.484-1.492-2.322-1.792-2.591a.349.349 0 01-.116-.257V7.248a.348.348 0 01.348-.348zm-7.63 0v2.182c4.983-.008 7.16 3.831 7.278 7.736a.348.348 0 00.348.334h1.488a.349.349 0 00.348-.36C17.257 11.141 13.82 6.9 7.935 6.9zM6.098 17.153h1.488a.348.348 0 00.349-.348V6.901H6.446a.697.697 0 00-.696.696v9.208a.348.348 0 00.348.348z",
    fill: "#257D98"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNobulLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nobul-logo.6581ed9d.svg";
export { ForwardRef as ReactComponent };